import { Field } from "formik";
import GetIcon from "../../../../utils/Icon";
import { useState } from "react";

const TextInput = ({ field, setFieldValue, values }) => {
    const [showPassword, setShowPassword] = useState(false);
    const isDisabled = (field.name === "discount" && values.flat) || (field.name === "flat" && values.discount);
  return (
    <div className="relative w-full"
      style={{ visibility: field.hidden ? "hidden" : "visible" }}
    >
      <Field
        type={field.type === "password" && showPassword ? "text" : field.type}
        name={field.name}
        placeholder={field.placeholder}
        className="w-full px-4 py-2 border border-gray-300 rounded-lg"
        disabled={isDisabled}
      />
      {field.type === "password" && (
        <span className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer" onClick={() => setShowPassword(!showPassword)}>
          <GetIcon iconName={showPassword ? "FaEyeSlash" : "FaEye"} size={20} design="text-gray-600" />
        </span>
      )}
    </div>
  );
};

export default TextInput;